import {getWXLoginInfo, loginByMobile, getCustomerInfo} from '../../api/api'
import store from '../..//store'
import router from '../../router'
import {Toast} from 'vant'

export function loginInfo(callback) { return _doWXLoginInfo(callback) }
export function isWixin() { return _isWixin() }
export function login(data, dialog) { return _doLogin(data, dialog) }
export function customerInfo(user, callback) { return _getCustomerInfo(user, callback) }

function _doWXLoginInfo(callback) {
    // alert("_doWXLoginInfo")
    getWXLoginInfo({
        data: {
            p: 1,
            url: window.location.href,
            reurl: window.location.href
        },
        success: data => {
            // alert("_doWXLoginInfo succ:"+data.data.url)
            // console.log(data)
            window.location.href = data.data.url
        },
        error: data => {
            // alert("fail")
            this.$toast.fail(data.msg)
            if (callback) {
                callback()
            }
        }
    })
}
function _isWixin() {
    let ua = window.navigator.userAgent.toLowerCase()
    if (/micromessenger/.test(ua)) {
        return true
    } else {
        return false
    }
}
function _doLogin(data, dialog) {
    store.commit('SET_LOADING', true)
    loginByMobile({
        data: data,
        success: data => {
            let user = {
                innerid: data.object.innerid,
                isperfect: data.object.isperfect,
                loginToken: data.object.loginToken,
                loginname: data.object.loginname,
                logourl: data.object.logourl,
                mobile: data.object.mobile,
                name: data.object.name,
                nickname: data.object.nickname,
                promoterid: data.object.promoterid,
                isLogin: true,
                zjmemtype: data.object.zjmemtype
            }
            store.commit('SET_USER', user)
            sessionStorage.setItem('user', JSON.stringify(user))
            store.commit('SET_LOADING', false)
            if (dialog.dialog) {
                store.commit('SET_DIALOGLOGIN', false)
            } else {
                router.back()
            }
        },
        error: data => {
            store.commit('SET_LOADING', false)
            Toast.fail(data.mesg)
        }
    })
}
function _getCustomerInfo(user, callback) {
    getCustomerInfo({
        data: {
            token: user.loginToken
        },
        success: data => {
            // console.log(data)
            // data.data.isperfect = 0
            let user = {
                innerid: data.data.innerid ? data.data.innerid : '',
                isperfect: data.data.isperfect ? data.data.isperfect : '',
                loginToken: data.data.loginToken ? data.data.loginToken : '',
                loginname: data.data.loginname ? data.data.loginname : '',
                logourl: data.data.logourl ? data.data.logourl : '',
                mobile: data.data.mobile ? data.data.mobile : '',
                name: data.data.name ? data.data.name : '',
                nickname: data.data.nickname ? data.data.nickname : '',
                promoterid: data.data.promoterid ? data.data.promoterid : '',
                isLogin: data.data.innerid ? true : false,
                zjmemtype: data.data.zjmemtype ? data.data.zjmemtype : 0
            }
            store.commit('SET_USER', user)
            sessionStorage.setItem('user', JSON.stringify(user))
            // 判断cookie中是否有token,如果有但是接口没有，就删除cookie中的token; 如果有并且接口也有，如果接口返的和cookie的不一致，就用接口的token替换cookie中的token
            if (data.data.loginToken) {
                let exp = new Date();//获取客户端本地当前系统时间
                exp.setTime(exp.getTime() + 86400 * 1000 * 7);//将exp设置为客户端本地时间7天以后，7天以后过期
                document.cookie = 'token=' + data.data.loginToken 
                + ";expires=" + exp.toUTCString()
                + ';path=/'
                + ';domain=' + window.location.hostname.split('.').slice(-2).join('.');
                // console.log(document.cookie)
            }
            else if (document.cookie.indexOf('token') !== -1) {
                let exp = new Date();//获取客户端本地当前系统时间
                exp.setTime(exp.getTime() - 60 * 1000);//将exp设置为客户端本地时间1分钟以前，将exp赋值给cookie作为过期时间后，就表示该cookie已经过期了, 那么浏览器就会将其立刻删除掉
                document.cookie = 'token="";expires=' + exp.toUTCString()
                + ';path=/'
                + ';domain=' + window.location.hostname.split('.').slice(-2).join('.');
            }
            if (callback) {
                callback()
            }
        },
        error: data => {
            Toast.fail(data.mesg)
            if (callback) {
                callback()
            }
        }
    })
}
